/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { TrimbleItemsControllerListProjectSightProjectsQueryResponse, TrimbleItemsControllerListProjectSightProjectsQueryParams } from "../../models/trimbleController/TrimbleItemsControllerListProjectSightProjects";

function getTrimbleItemsControllerListProjectSightProjectsUrl() {
  const res = { method: 'GET', url: `/api/v1/trimble/projectsight/projects` as const }  
  return res
}

/**
 * @summary List the caller's ProjectSight projects with service-credential access status
 * {@link /api/v1/trimble/projectsight/projects}
 */
export async function trimbleItemsControllerListProjectSightProjects(params: TrimbleItemsControllerListProjectSightProjectsQueryParams, config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const res = await request<TrimbleItemsControllerListProjectSightProjectsQueryResponse, ResponseErrorConfig<Error>, unknown>({ method : "GET", url : getTrimbleItemsControllerListProjectSightProjectsUrl().url.toString(), params, ... requestConfig })  
  return res.data
}